/// <reference path="app.ts" />
/// <reference path="components/interceptors/interceptors.module.ts" />
/// <reference path="components/short-cuts/index.d.ts" />

module Meevo {
    "use strict";

    const ShortCutGroup = Meevo.Components.ShortCuts.ShortCutGroup;

    config.$inject = [
        "$windowProvider",
        "meevo.AppSettings",
        "$httpProvider",
        "$stateProvider",
        "$stickyStateProvider",
        "$urlRouterProvider",
        "$locationProvider",
        "$translateProvider",
        "$mdDateLocaleProvider",
        "$mdAriaProvider",
        "$sceDelegateProvider",
        "tmhDynamicLocaleProvider",
        "ngIntlTelInputProvider",
        "$provide"
    ];

    let regexIso8601 = /^(\d{4}|\+\d{6})(?:-(\d{2})(?:-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})\.(\d{1,})(Z|([\-+])(\d{2}):(\d{2}))?)?)?)?$/;

    function config(
        $windowProvider: any,
        appSettings: Meevo.Components.Common.IAppSettings,
        $httpProvider: any,
        $stateProvider: ng.ui.IStateProvider,
        $stickyStateProvider: any,
        $urlRouterProvider: ng.ui.IUrlRouterProvider,
        $locationProvider: ng.ILocationProvider,
        $translateProvider: any,
        $mdDateLocaleProvider: any,
        $mdAriaProvider: any,
        $sceDelegateProvider: any,
        tmhDynamicLocaleProvider: any,
        ngIntlTelInputProvider: any,
        $provide): void {

        $httpProvider.interceptors.push("meevo.components.interceptors.JwtInterceptor");

        let routeNames = appSettings.ROUTE_NAMES;
        let auditNames = appSettings.AUDIT_NAMES;

        $stickyStateProvider.enableDebug(true);

        var $window = $windowProvider.$get();
        var meevoCdn = $window.MEEVOCDN || '';

        ngIntlTelInputProvider.set({
            initialCountry: 'us',
            utilsScript: meevoCdn + '/lib/utils.js',
            autoPlaceholder: "off",
            nationalMode: true
        });

        //ngIntlTelInputProvider.set({
        //    geoIpLookup: function (callback) {
        //        $.get('http://ipinfo.io', function () { }, "jsonp").always(function (resp) {
        //            var countryCode = (resp && resp.country) ? resp.country : "sg";
        //            callback(countryCode);
        //        });
        //    }
        //});

        var serverEventsApiRootURL = $window.SERVEREVENTSAPIROOTURL || ''
        appSettings.SERVER_EVENTS_API_URL = serverEventsApiRootURL;
        appSettings.SERVER_EVENTS_ENABLED = $window.SERVEREVENTSENABLED.toBoolean();

        configureTranslations($translateProvider, meevoCdn, appSettings.APP_COUNTRYID);
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
        $translateProvider.useInterpolation('meevoTranslateInterpolation');

        configuretmhDynamicLocaleProvider(tmhDynamicLocaleProvider, appSettings.APP_COUNTRYID);
        configureDateLocaleProvider($mdDateLocaleProvider);
        $mdAriaProvider.disableWarnings();

        /*  https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider
        **  $sceDelegateProvider get/set the whitelists and blacklists used to ensure that the URLs used
        **  for sourcing AngularJS templates and other script-running URLs are safe
        */
        //var AwsCdnWhitelist =
        //$sceDelegateProvider.resourceUrlWhitelist([
        //    // Allow same origin resource loads.
        //    'self',
        //    //Allow loading from our assets domain. '**' includes sub folder contents
        //    '*:' + MEEVOCDN.split(':')[1] + '/**'
        //]);

        var contexts = [
            {
                name: routeNames.home,
                title: 'HERO_SUB_SMARTCENTER',
                templateUrl: 'app/plugins/smartCenter/smartCenterTemplate.html',
                specialName: "'" + routeNames.home + "'",
                auditName: auditNames.home,
                isHomeContext: false,
                noun: Meevo.Model.NounEnum.Home,
                params: {
                    timeStamp: null
                },
                close: function (): void
                {
                    const backgroundElem: HTMLElement = document.getElementById('default-background');
                    const smartCenterElem: HTMLElement = document.getElementById('smart-center-content');

                    if (backgroundElem && smartCenterElem) {
                        smartCenterElem.setAttribute('style', 'display: none');
                        backgroundElem.setAttribute('style', 'display: ');

                        this.title = "LABEL_HOME";
                        this.isHomeContext = true;

                        //remove X button on home.
                        const xButton = document.getElementsByClassName('homeTileClose')[0];
                        if (xButton) {
                            xButton.setAttribute('style', 'display: none');
                        }
                    }
                }
            },
            {
                name: routeNames.appointmentBook,
                title: 'HERO_SUB_APPOINTMENTBOOK',
                specialName: "'" + routeNames.appointmentBook + "'",
                sticky: true,
                params: {
                    actionState: null,
                    actionStatePayload: null,
                    employeeAction: null,
                    filters: null,
                    employees: null,
                    dates: null
                    //dateAction: null
                },
                views: {
                    appointmentBook: {
                        templateUrl: 'app/plugins/AppointmentBook/views/index.html',
                        controller: ''
                    }
                },
                noun: Meevo.Model.NounEnum.AppointmentBookPage
            },
            {
                name: routeNames.register,
                title: 'HERO_SUB_REGISTER',
                specialName: "'" + routeNames.register + "'",
                sticky: true,
                views: {
                    register: {
                        templateUrl: 'app/plugins/register/index.html',
                        controller: 'meevo.plugins.register.RegisterController',
                        controllerAs: 'register'
                    }
                },
                warnUponClose: true,
                noun: Meevo.Model.NounEnum.RegisterPage
            },
            {
                name: routeNames.discounts,
                title: 'HERO_SUB_DISCOUNTS',
                specialName: "'" + routeNames.discounts + "'",
                auditName: auditNames.discounts,
                sticky: true,
                views: {
                    discounts: {
                        templateUrl: 'app/plugins/discounts/index.html',
                        controller: 'meevo.plugins.discounts.DiscountsController',
                        controllerAs: 'discounts'
                    }
                },
                noun: Meevo.Model.NounEnum.DiscountSearchPage
            },
            {
                name: routeNames.posHardware,
                specialName: "'" + routeNames.posHardware + "'",
                title: 'HERO_SUB_POS_HARDWARE',
                sticky: true,
                views: {
                    posHardware: {
                        templateUrl: 'app/plugins/posHardware/index.html',
                        controller: 'meevo.plugins.posHardware.PosHardwareController',
                        controllerAs: 'posHardware'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.PosHardwareReceiptPrinter
            },
            {
                name: routeNames.drawer,
                title: "HERO_SUB_DRAWER",
                specialName: "'" + routeNames.drawer + "'",
                auditName: auditNames.drawer,
                sticky: true,
                views: {
                    drawer: {
                        templateUrl: "app/plugins/drawer/index.html",
                        controller: "meevo.plugins.drawer.DrawerController",
                        controllerAs: "drawer"
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.DrawerSearchPage
            },
            {
                name: routeNames.floorLocation,
                title: "HERO_SUB_FLOOR_LOCATION",
                specialName: "'" + routeNames.floorLocation + "'",
                auditName: auditNames.floorLocation,
                sticky: true,
                views: {
                    floorLocation: {
                        templateUrl: "app/plugins/floorLocation/index.html",
                        controller: "meevo.plugins.floorLocation.FloorLocationController",
                        controllerAs: "floorLocation"
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.FloorLocationSearchPage
            },
            {
                name: routeNames.drawerHistory,
                title: "HERO_SUB_DRAWER_HISTORY",
                specialName: "'" + routeNames.drawerHistory + "'",
                auditName: auditNames.drawerHistory,
                sticky: true,
                views: {
                    drawerHistory: {
                        templateUrl: "app/plugins/drawerManager/index.html",
                        controller: "meevo.plugins.drawerManager.DrawerManagerController",
                        controllerAs: "drawerManager"
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: "DrawerHistory",
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.DrawerHistoryPage
            },
            {
                name: routeNames.drawerManager,
                title: "HERO_SUB_DRAWER_MANAGER",
                specialName: "'" + routeNames.drawerManager + "'",
                auditName: auditNames.drawerManager,
                sticky: true,
                views: {
                    drawerManager: {
                        templateUrl: "app/plugins/drawerManager/index.html",
                        controller: "meevo.plugins.drawerManager.DrawerManagerController",
                        controllerAs: "drawerManager"
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.DrawerManagerPage
            },
            {
                name: routeNames.transactionEditor,
                title: 'HERO_SUB_TRANSACTION_EDITOR',
                specialName: "'" + routeNames.transactionEditor + "'",
                auditName: auditNames.transactionEditor,
                sticky: true,
                views: {
                    transactionEditor: {
                        templateUrl: 'app/plugins/transactionEditor/index.html',
                        controller: 'meevo.plugins.transactionEditor.TransactionEditorController',
                        controllerAs: 'transactionEditor'
                    }
                },
                warnUponClose: false,
                noun: Meevo.Model.NounEnum.TransactionEditorPage
            },
            {
                name: routeNames.saleProgram,
                title: 'HERO_SUB_MARK_ITEMS_ON_SALE',
                specialName: "'" + routeNames.saleProgram + "'",
                auditName: auditNames.saleProgram,
                sticky: true,
                views: {
                    saleProgram: {
                        templateUrl: 'app/plugins/saleProgram/index.html',
                        controller: 'meevo.plugins.saleProgram.SaleProgramController',
                        controllerAs: 'saleProgram'
                    }
                },
                warnUponClose: false,
                noun: Meevo.Model.NounEnum.MarkItemsOnSaleSearchPage
            },
            {
                name: routeNames.businessInfo,
                specialName: "'" + routeNames.businessInfo + "'",
                title: 'Business Information',
                sticky: true,
                views: {
                    businessInfo: {
                        templateUrl: 'app/plugins/businessInfo/index.html',
                        controller: 'meevo.plugins.businessInfo.BusinessInfoController',
                        controllerAs: 'businessInfo'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.BusinessInfoMain
            },
            {
                name: routeNames.businessTypes,
                specialName: "'" + routeNames.businessTypes + "'",
                auditName: auditNames.businessTypes,
                title: 'Business Types',
                sticky: true,
                views: {
                    businessTypes: {
                        templateUrl: 'app/plugins/businessTypes/index.html',
                        controller: 'meevo.plugins.businessTypes.BusinessTypesController',
                        controllerAs: 'businessTypes'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.BusinessTypeSearchPage
            },
            {
                name: routeNames.locationGroups,
                specialName: "'" + routeNames.locationGroups + "'",
                auditName: auditNames.locationGroups,
                title: 'Location Groups',
                sticky: true,
                views: {
                    locationGroups: {
                        templateUrl: 'app/plugins/locationGroups/index.html',
                        controller: 'meevo.plugins.locationGroups.LocationGroupsController',
                        controllerAs: 'locationGroups'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.LocationGroupSearchPage
            },
            {
                name: routeNames.location,
                specialName: "'" + routeNames.location + "'",
                auditName: auditNames.location,
                title: 'Locations',
                sticky: true,
                views: {
                    location: {
                        templateUrl: 'app/plugins/location/index.html',
                        controller: 'meevo.plugins.location.LocationController',
                        controllerAs: 'location'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.LocationMaintenanceSearchPage
            },
            //{
            //  name: routeNames.onlineBooking,
            //  specialName: "'" + routeNames.onlineBooking + "'",
            //  title: 'Online Booking',
            //  //url: '/onlineBooking',
            //  sticky: true,
            //  views: {
            //    onlineBooking: {
            //      templateUrl: './app/components/contentHost/contentHost.html',
            //      controller: 'ContentHostCtrl as hostController'
            //    }
            //  },
            //  data: {
            //    url: 'https://mdev.meevoqa.com/onlinebooking/'
            //  }
            //},
            {
                name: routeNames.styleGallery,
                specialName: "'" + routeNames.styleGallery + "'",
                title: 'StyleGuide',
                //  url: '/styleGuide',
                templateUrl: 'app/plugins/styleGallery/styleGallery.html',
                controller: 'meevo.plugins.styleGallery.StyleGalleryController',
                controllerAs: 'style'
            },
            {
                name: routeNames.controlGallery,
                specialName: "'" + routeNames.controlGallery + "'",
                title: 'Control Gallery',
                //url: '/plugins/controlgallery',
                templateUrl: 'app/plugins/controlgallery/controlGallery.html',
                controller: 'meevo.plugins.controlgallery.ControlGalleryController',
                controllerAs: 'controlGallery',
                params: {
                    callback: null,
                    callbackState: null
                }
            },
            {
                name: routeNames.callCenter,
                specialName: "'" + routeNames.callCenter + "'",
                title: 'Booking Agent',
                sticky: true,
                views: {
                    bookingAgent: {
                        templateUrl: 'app/plugins/callCenter/index.html',
                        controller: 'meevo.plugins.callCenter.CallCenterController',
                        controllerAs: 'bookingAgent',
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.BookingAgent
            },
            {
                name: routeNames.client,
                specialName: "'" + routeNames.client + "'",
                auditName: auditNames.client,
                title: 'HERO_SUB_CLIENTS',
                sticky: true,
                views: {
                    client: {
                        templateUrl: 'app/plugins/client/index.html',
                        controller: 'meevo.plugins.client.ClientController',
                        controllerAs: 'client',
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null,
                    initialEditSection: null
                },
                noun: Meevo.Model.NounEnum.ClientSearchPage
            },
            {
                name: routeNames.clientClientType,
                specialName: "'" + routeNames.clientClientType + "'",
                auditName: auditNames.clientClientType,
                title: 'HERO_SUB_CLIENTCLIENTTYPE',
                sticky: true,
                views: {
                    clientClientType: {
                        templateUrl: 'app/plugins/clientClientType/index.html',
                        controller: 'meevo.plugins.clientClientType.ClientClientTypeController',
                        controllerAs: 'clientClientType',
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ClientTypeSearchPage
            },
            {
                name: routeNames.employee,
                specialName: "'" + routeNames.employee + "'",
                auditName: auditNames.employee,
                title: 'HERO_SUB_EMPLOYEES',
                sticky: true,
                views: {
                    employee: {
                        templateUrl: 'app/plugins/employee/index.html',
                        controller: 'meevo.plugins.employee.EmployeeController',
                        controllerAs: 'employee'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.EmployeeSearchPage
            },
            {
                name: routeNames.teachers,
                specialName: "'" + routeNames.teachers + "'",
                auditName: auditNames.teachers,
                title: 'HERO_SUB_TEACHERS',
                sticky: true,
                views: {
                    teachers: {
                        templateUrl: 'app/plugins/teachers/index.html',
                        controller: 'meevo.plugins.teachers.TeachersController',
                        controllerAs: 'teachers'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.TeacherSearchPage
            },
            {
                name: routeNames.payinoutreasons,
                specialName: "'" + routeNames.payinoutreasons + "'",
                auditName: auditNames.payinoutreasons,
                title: 'HERO_SUB_PAYINOUT_REASON',
                sticky: true,
                views: {
                    payinoutreasons: {
                        templateUrl: 'app/plugins/payinoutreasons/index.html',
                        controller: 'meevo.plugins.payinoutreasons.PayInOutReasonsController',
                        controllerAs: 'PayInOutReasons'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.PayInOutReasonSearchPage
            },
            {
                name: routeNames.memberships,
                specialName: "'" + routeNames.memberships + "'",
                auditName: auditNames.memberships,
                title: 'Memberships',
                sticky: true,
                views: {
                    memberships: {
                        templateUrl: 'app/plugins/memberships/index.html',
                        controller: 'meevo.plugins.memberships.MembershipsController',
                        controllerAs: 'memberships'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.MembershipSearchPage
            },
            {
                name: routeNames.memberBenefitTemplates,
                specialName: "'" + routeNames.memberBenefitTemplates + "'",
                auditName: auditNames.memberBenefitTemplates,
                title: 'Member Benefits Templates',
                sticky: true,
                views: {
                    memberBenefitTemplates: {
                        templateUrl: 'app/plugins/memberBenefitTemplates/index.html',
                        controller: 'meevo.plugins.memberBenefitTemplates.memberBenefitTemplatesController',
                        controllerAs: 'memberBenefitTemplates'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.MemberBenefitTemplateSearchPage
            },
            {
                name: routeNames.membershipCancellation,
                specialName: "'" + routeNames.membershipCancellation + "'",
                auditName: auditNames.membershipCancellation,
                title: 'Membership Cancellation Reasons',
                sticky: true,
                views: {
                    membershipCancellation: {
                        templateUrl: 'app/plugins/membershipCancellation/index.html',
                        controller: 'meevo.plugins.membershipCancellation.membershipCancellationController',
                        controllerAs: 'membershipCancellation'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.MembershipCancellationReasonSearchPage
            },
            {
                name: routeNames.membershipManager,
                specialName: "'" + routeNames.membershipManager + "'",
                auditName: auditNames.membershipManager,
                title: 'Membership Manager',
                sticky: true,
                warnUponClose: true,
                views: {
                    membershipManager: {
                        templateUrl: 'app/plugins/membershipManager/index.html',
                        controller: 'meevo.plugins.membershipManager.membershipManagerController',
                        controllerAs: 'membershipManager'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.MembershipManagerPage
            },
            {
                name: routeNames.membershipTypes,
                specialName: "'" + routeNames.membershipTypes + "'",
                auditName: auditNames.membershipTypes,
                title: 'Membership Types',
                sticky: true,
                views: {
                    membershipTypes: {
                        templateUrl: 'app/plugins/membershipTypes/index.html',
                        controller: 'meevo.plugins.membershipTypes.MembershipTypesController',
                        controllerAs: 'membershipTypes'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.MembershipTypeSearchPage
            },
            {
                name: routeNames.eftControlPanel,
                specialName: "'" + routeNames.eftControlPanel + "'",
                auditName: auditNames.eftControlPanel,
                title: 'EFT Control Panel',
                sticky: true,
                views: {
                    eftControlPanel: {
                        templateUrl: 'app/plugins/eftControlPanel/index.html',
                        controller: 'meevo.plugins.eftControlPanel.EftControlPanelController',
                        controllerAs: 'eftControlPanel'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.EftControlPanelPage
            },
            {
                name: routeNames.membershipDefinitions,
                specialName: "'" + routeNames.membershipDefinitions + "'",
                title: 'Membership Definitions',
                sticky: true,
                views: {
                    membershipDefinitions: {
                        templateUrl: 'app/plugins/membershipDefinitions/index.html',
                        controller: 'meevo.plugins.membershipDefinitions.MembershipDefinitionsController',
                        controllerAs: 'membershipDefinitions'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: ""
            },
            {
                name: routeNames.product,
                specialName: "'" + routeNames.product + "'",
                auditName: auditNames.product,
                title: 'HERO_SUB_PRODUCTS',
                sticky: true,
                views: {
                    product: {
                        templateUrl: 'app/plugins/product/index.html',
                        controller: 'meevo.plugins.product.ProductController',
                        controllerAs: 'product'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ProductSearchPage
            },
            //{
            //    name: routeNames.productBulkUpdate,
            //    specialName: "'" + routeNames.productBulkUpdate + "'",
            //    auditName: auditNames.productBulkUpdate,
            //    title: 'HERO_SUB_PRODUCT_BULK_UPDATE',
            //    sticky: true,
            //    views: {
            //        productBulkUpdate: {
            //            templateUrl: 'app/plugins/productBulkUpdate/index.html',
            //            controller: 'meevo.plugins.productBulkUpdate.ProductBulkUpdateController',
            //            controllerAs: 'productBulkUpdate'
            //        }
            //    },
            //    params: {
            //        callback: null,
            //        callbackState: null,
            //        targetState: null,
            //        actionState: null,
            //        id: null
            //    },
            //    noun: Meevo.Model.NounEnum.ProductBulkUpdateSearchPage
            //},
            {
                name: routeNames.cancellationReasons,
                specialName: "'" + routeNames.cancellationReasons + "'",
                auditName: auditNames.cancellationReasons,
                title: 'HERO_SUB_CANCELLATION_REASONS',
                sticky: true,
                views: {
                    cancellationReasons: {
                        templateUrl: 'app/plugins/cancellationReasons/index.html',
                        controller: 'meevo.plugins.cancellationReasons.CancellationReasonsController',
                        controllerAs: 'cancellationReasons'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.CancellationReaonSearchPage
            },
            {
                name: routeNames.services,
                specialName: "'" + routeNames.services + "'",
                auditName: auditNames.services,
                title: 'HERO_SUB_SERVICES',
                sticky: true,
                views: {
                    services: {
                        templateUrl: 'app/plugins/services/index.html',
                        controller: 'meevo.plugins.services.ServicesController',
                        controllerAs: 'services'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ServiceSearchPage
            },
            {
                name: routeNames.swapGroups,
                specialName: "'" + routeNames.swapGroups + "'",
                auditName: auditNames.swapGroups,
                title: 'Swap Groups',
                sticky: true,
                views: {
                    swapGroups: {
                        templateUrl: 'app/plugins/swapGroups/index.html',
                        controller: 'meevo.plugins.swapGroups.SwapGroupsController',
                        controllerAs: 'swapGroups'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.SwapGroupSearchPage
            },
            {
                name: routeNames.referralTypes,
                specialName: "'" + routeNames.referralTypes + "'",
                auditName: auditNames.referralTypes,
                title: 'Referral Types',
                sticky: true,
                views: {
                    referralTypes: {
                        templateUrl: 'app/plugins/referralTypes/index.html',
                        controller: 'meevo.plugins.referralTypes.ReferralTypesController',
                        controllerAs: 'referralTypes'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ReferralTypeSearchPage
            },
            {
                name: routeNames.resourceCategory,
                specialName: "'" + routeNames.resourceCategory + "'",
                auditName: auditNames.resourceCategory,
                title: 'HERO_SUB_RESOURCE_CATEGORIES',
                sticky: true,
                views: {
                    resourceCategory: {
                        templateUrl: 'app/plugins/resourceCategories/index.html',
                        controller: 'meevo.plugins.resourceCategories.ResourceCategoriesController',
                        controllerAs: 'resourceCategories'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ResourceCategorySearchPage
            },
            {
                name: routeNames.resources,
                specialName: "'" + routeNames.resources + "'",
                auditName: auditNames.resources,
                title: 'HERO_SUB_RESOURCES',
                sticky: true,
                views: {
                    resources: {
                        templateUrl: 'app/plugins/resources/index.html',
                        controller: 'meevo.plugins.resources.ResourcesController',
                        controllerAs: 'resources'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ResourceSearchPage
            },
            {
                name: routeNames.appointmentCategories,
                specialName: "'" + routeNames.appointmentCategories + "'",
                auditName: auditNames.appointmentCategories,
                title: 'HERO_SUB_APPOINTMENT_CATEGORY',
                sticky: true,
                views: {
                    appointmentCategories: {
                        templateUrl: 'app/plugins/appointmentCategories/index.html',
                        controller: 'meevo.plugins.appointmentCategories.AppointmentCategoriesController',
                        controllerAs: 'appointmentCategories'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.AppointmentCategorySearchPage
            },
            {
                name: routeNames.blockTypes,
                specialName: "'" + routeNames.blockTypes + "'",
                auditName: auditNames.blockTypes,
                title: 'HERO_SUB_BLOCK_TYPES',
                sticky: true,
                views: {
                    blockTypes: {
                        templateUrl: 'app/plugins/blockTypes/index.html',
                        controller: 'meevo.plugins.blockTypes.BlockTypesController',
                        controllerAs: 'blockTypes'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.BlockTypeSearchPage
            },
            {
                name: routeNames.miscSupplyDefinitions,
                specialName: "'" + routeNames.miscSupplyDefinitions + "'",
                auditName: auditNames.miscSupplyDefinitions,
                title: 'Misc. Supply',
                sticky: true,
                views: {
                    miscSupplyDefinitions: {
                        templateUrl: 'app/plugins/miscSupplyDefinitions/index.html',
                        controller: 'meevo.plugins.miscSupplyDefinitions.MiscSupplyDefinitionsController',
                        controllerAs: 'miscSupplyDefinitions'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.MiscellaneousSupplySearchPage
            },
            {
                name: routeNames.workActivities,
                specialName: "'" + routeNames.workActivities + "'",
                auditName: auditNames.workActivities,
                title: 'Work Activities',
                sticky: true,
                views: {
                    workActivities: {
                        templateUrl: 'app/plugins/workActivities/index.html',
                        controller: 'meevo.plugins.workActivities.WorkActivitiesController',
                        controllerAs: 'workActivities'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.WorkActivitySearchPage
            },
            {
                name: routeNames.reports,
                specialName: "'" + routeNames.reports + "'",
                title: 'HERO_SUB_REPORTS',
                sticky: true,
                views: {
                    reports: {
                        templateUrl: 'app/plugins/reports/index.html',
                        controller: 'meevo.plugins.reports.ReportsController',
                        controllerAs: 'reports'
                    }
                },
                params: {
                    categoryId: null,
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ReportPage
            },
            {
                name: routeNames.reportScheduler,
                specialName: "'" + routeNames.reportScheduler + "'",
                title: 'HERO_SUB_REPORT_SCHEDULER',
                sticky: true,
                views: {
                    reportScheduler: {
                        templateUrl: 'app/plugins/reportScheduler/index.html',
                        controller: 'meevo.plugins.reportScheduler.ReportSchedulerController',
                        controllerAs: 'reportScheduler'
                    }
                },
                params: {
                    categoryId: null,
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ReportPage
            },
            {
                name: routeNames.visitNoteTypes,
                specialName: "'" + routeNames.visitNoteTypes + "'",
                auditName: auditNames.visitNoteTypes,
                title: 'Visit Notes',
                sticky: true,
                views: {
                    visitNoteTypes: {
                        templateUrl: 'app/plugins/visitNoteTypes/index.html',
                        controller: 'meevo.plugins.visitNoteTypes.VisitNoteTypesController',
                        controllerAs: 'visitNoteTypes'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.VisitNoteTypeSearchPage
            },
            {
                name: routeNames.standingAppointments,
                specialName: "'" + routeNames.standingAppointments + "'",
                auditName: auditNames.standingAppointments,
                title: 'HERO_SUB_STANDING_APPOINTMENTS',
                sticky: true,
                views: {
                    standingAppointments: {
                        templateUrl: 'app/plugins/standingAppointments/index.html',
                        controller: 'meevo.plugins.standingAppointments.StandingAppointmentsController',
                        controllerAs: 'standingAppointments'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.StandingDefinitionSearchPage
            },
            {
                name: routeNames.standingBlocks,
                specialName: "'" + routeNames.standingBlocks + "'",
                auditName: auditNames.standingBlocks,
                title: 'HERO_SUB_STANDING_BLOCKS',
                sticky: true,
                views: {
                    standingBlocks: {
                        templateUrl: 'app/plugins/standingBlocks/index.html',
                        controller: 'meevo.plugins.standingBlocks.StandingBlocksController',
                        controllerAs: 'standingBlocks'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.BlockScheduleSearchPage
            },
            {
                name: routeNames.login,
                specialName: "'" + routeNames.login + "'",
                title: 'Login',
                //url: '/login',
                templateUrl: 'app/plugins/login/login.html',
                controller: 'meevo.plugins.login.LoginController',
                controllerAs: 'login',
                noun: Meevo.Model.NounEnum.Login
            },
            {
                name: routeNames.confirmationManager,
                specialName: "'" + routeNames.confirmationManager + "'",
                auditName: auditNames.confirmationManager,
                title: 'HERO_SUB_CONFIRMATION_MANAGER',
                sticky: true,
                views: {
                    confirmationManager: {
                        templateUrl: 'app/plugins/confirmationManager/index.html',
                        controller: 'meevo.plugins.confirmationManager.ConfirmationManagerController',
                        controllerAs: 'confirmationManager'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ConfirmationManagerPage
            },
            {
                name: routeNames.serviceCategories,
                specialName: "'" + routeNames.serviceCategories + "'",
                title: 'HERO_SUB_SERVICE_CAT',
                sticky: true,
                views: {
                    serviceCategories: {
                        templateUrl: 'app/plugins/serviceCategories/index.html',
                        controller: 'meevo.plugins.serviceCategories.ServiceCategoriesController',
                        controllerAs: 'serviceCategories'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ServiceCategorySearchPage
            },
            {
                name: routeNames.productCategories,
                specialName: "'" + routeNames.productCategories + "'",
                auditName: auditNames.productCategories,
                title: 'HERO_SUB_PRODUCT_CAT',
                sticky: true,
                views: {
                    productCategories: {
                        templateUrl: 'app/plugins/productCategories/index.html',
                        controller: 'meevo.plugins.productCategories.ProductCategoriesController',
                        controllerAs: 'productCategories'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ProductCategorySearchPage
            },
            {
                name: routeNames.distributors,
                specialName: "'" + routeNames.distributors + "'",
                auditName: auditNames.distributors,
                title: 'HERO_SUB_DISTRIBUTORS',
                sticky: true,
                views: {
                    distributors: {
                        templateUrl: 'app/plugins/distributors/index.html',
                        controller: 'meevo.plugins.distributors.DistributorsController',
                        controllerAs: 'distributors'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.DistributorSearchPage
            },
            {
                name: routeNames.manufacturers,
                specialName: "'" + routeNames.manufacturers + "'",
                auditName: auditNames.manufacturers,
                title: 'HERO_SUB_MANUFACTURERS',
                sticky: true,
                views: {
                    manufacturers: {
                        templateUrl: 'app/plugins/manufacturers/index.html',
                        controller: 'meevo.plugins.manufacturers.ManufacturersController',
                        controllerAs: 'manufacturers'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ManufacturerSearchPage
            },
            {
                name: routeNames.employeeTemplates,
                specialName: "'" + routeNames.employeeTemplates + "'",
                auditName: auditNames.employeeTemplates,
                title: 'HERO_SUB_EMPLOYEE_TEMPLATE',
                sticky: true,
                views: {
                    employeeTemplates: {
                        templateUrl: 'app/plugins/employeeTemplates/index.html',
                        controller: 'meevo.plugins.employeeTemplates.EmployeeTemplatesController',
                        controllerAs: 'employeeTemplates'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.EmployeeTemplateSearchPage
            },
            {
                name: routeNames.employeeTemplatePromotions,
                specialName: "'" + routeNames.employeeTemplatePromotions + "'",
                auditName: auditNames.employeeTemplatePromotions,
                title: 'HERO_SUB_EMPLOYEE_TEMPLATE_PROMOTIONS',
                sticky: true,
                views: {
                    employeeTemplatePromotions: {
                        templateUrl: 'app/plugins/employeeTemplatePromotions/index.html',
                        controller: 'meevo.plugins.employeeTemplatePromotions.EmployeeTemplatePromotionsController',
                        controllerAs: 'employeeTemplatePromotions'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.EmployeePromotionSearchPage
            },
            {
                name: routeNames.employeeCategories,
                specialName: "'" + routeNames.employeeCategories + "'",
                auditName: auditNames.employeeCategories,
                title: 'HERO_SUB_EMPLOYEE_CATEGORY',
                sticky: true,
                views: {
                    employeeCategories: {
                        templateUrl: 'app/plugins/employeeCategories/index.html',
                        controller: 'meevo.plugins.employeeCategories.EmployeeCategoriesController',
                        controllerAs: 'employeeCategories'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.EmployeeCategorySearchPage
            },
            {
                name: routeNames.securityRoles,
                specialName: "'" + routeNames.securityRoles + "'",
                auditName: auditNames.securityRoles,
                title: 'Security Roles',
                sticky: true,
                views: {
                    securityRoles: {
                        templateUrl: 'app/plugins/securityRoles/index.html',
                        controller: 'meevo.plugins.securityRoles.SecurityRolesController',
                        controllerAs: 'securityRoles'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.SecurityRoleSearchPage
            },
            {
                name: routeNames.securityRolesManager,
                specialName: "'" + routeNames.securityRolesManager + "'",
                auditName: auditNames.securityRolesManager,
                title: 'Security Administration',
                sticky: true,
                views: {
                    securityRolesManager: {
                        templateUrl: 'app/plugins/securityRolesManager/index.html',
                        controller: 'meevo.plugins.securityRolesManager.SecurityRolesManagerController',
                        controllerAs: 'securityRolesManager'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.SecurityRolesManagerPage
            },
            {
                name: routeNames.waitList,
                specialName: "'" + routeNames.waitList + "'",
                title: 'Wait List',
                sticky: true,
                views: {
                    waitList: {
                        templateUrl: 'app/plugins/waitList/index.html',
                        controller: 'meevo.plugins.waitList.WaitListController',
                        controllerAs: 'waitList'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.WaitListPage
            },
            {
                name: routeNames.clientMerge,
                specialName: "'" + routeNames.clientMerge + "'",
                auditName: auditNames.clientMerge,
                title: 'Intelli-Merge Clients',
                sticky: true,
                views: {
                    clientMerge: {
                        templateUrl: 'app/plugins/clientMerge/index.html',
                        controller: 'meevo.plugins.clientMerge.ClientMergeController',
                        controllerAs: 'clientMerge'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.IntelliMergePage
            },
            {
                name: routeNames.clientManualMerge,
                specialName: "'" + routeNames.clientManualMerge + "'",
                auditName: auditNames.clientManualMerge,
                title: 'Manual Merge Clients',
                sticky: true,
                views: {
                    clientManualMerge: {
                        templateUrl: 'app/plugins/clientManualMerge/index.html',
                        controller: 'meevo.plugins.clientManualMerge.ClientManualMergeController',
                        controllerAs: 'clientManualMerge'
                    }
                },
                noun: Meevo.Model.NounEnum.ClientManualMerge
            },
            {
                name: routeNames.sandbox,
                specialName: "'" + routeNames.sandbox + "'",
                title: 'Sandbox',
                sticky: true,
                views: {
                    sandbox: {
                        templateUrl: 'app/plugins/sandbox/index.html',
                        controller: 'meevo.plugins.sandbox.SandboxController',
                        controllerAs: 'sandbox'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ClientNote // TODO: Replace with Correct Noun
            },
            {
                name: routeNames.customBranding,
                specialName: "'" + routeNames.customBranding + "'",
                title: 'Custom Branding',
                sticky: true,
                views: {
                    customBranding: {
                        templateUrl: 'app/plugins/customBranding/index.html',
                        controller: 'meevo.plugins.customBranding.CustomBrandingController',
                        controllerAs: 'customBranding'
                    }
                },
                noun: Meevo.Model.NounEnum.CustomBranding
            },
            {
                name: routeNames.integrations,
                title: 'Integrations',
                specialName: "'" + routeNames.integrations + "'",
                sticky: true,
                views: {
                    integrations: {
                        templateUrl: 'app/plugins/integrations/index.html',
                        controller: 'meevo.plugins.integrations.IntegrationsController',
                        controllerAs: 'integrations'
                    }
                },
                noun: Meevo.Model.NounEnum.Integration
            },
            {
                name: routeNames.addOnGroup,
                title: 'HERO_SUB_SERVICE_ADD_ON_MAPPINGS',
                specialName: "'" + routeNames.addOnGroup + "'",
                auditName: auditNames.addOnGroup,
                sticky: true,
                views: {
                    addOnGroup: {
                        templateUrl: 'app/plugins/addOnGroup/index.html',
                        controller: 'meevo.plugins.addOnGroup.AddOnGroupController',
                        controllerAs: 'addOnGroup'
                    }
                },
                noun: Meevo.Model.NounEnum.ServiceAddOnMappingSearchPage
            },
            {
                name: routeNames.productBundles,
                title: 'HERO_SUB_PRODUCT_BUNDLES',
                specialName: "'" + routeNames.productBundles + "'",
                auditName: auditNames.productBundles,
                sticky: true,
                views: {
                    productBundles: {
                        templateUrl: 'app/plugins/productBundles/index.html',
                        controller: 'meevo.plugins.productBundles.ProductBundlesController',
                        controllerAs: 'productBundles'
                    }
                },
                // todo: use appropriate enum
                noun: Meevo.Model.NounEnum.ProductBundleSearchPage
            },
            {
                name: routeNames.onlineBookingSettings,
                specialName: "'" + routeNames.onlineBookingSettings + "'",
                title: 'Online Booking Settings',
                sticky: true,
                views: {
                    onlineBookingSettings: {
                        templateUrl: 'app/plugins/onlineBookingSettings/index.html',
                        controller: 'meevo.plugins.onlineBookingSettings.OnlineBookingSettingsController',
                        controllerAs: 'onlineBookingSettings'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.OnlineBookingSetting
            },
            {
                name: routeNames.paymentType,
                specialName: "'" + routeNames.paymentType + "'",
                auditName: auditNames.paymentType,
                title: 'Payment Types',
                sticky: true,
                views: {
                    paymentType: {
                        templateUrl: 'app/plugins/paymentType/index.html',
                        controller: 'meevo.plugins.paymentType.PaymentTypeController',
                        controllerAs: 'paymentType'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.PaymentTypeSearchPage
            },
            {
                name: routeNames.stockLevels,
                specialName: "'" + routeNames.stockLevels + "'",
                title: 'Stock Levels',
                sticky: true,
                views: {
                    stockLevels: {
                        templateUrl: 'app/plugins/stockLevels/index.html',
                        controller: 'meevo.plugins.stockLevels.StockLevelsController',
                        controllerAs: 'stockLevels'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.StockLevelPage
            },
            {
                name: routeNames.inventoryCount,
                specialName: "'" + routeNames.inventoryCount + "'",
                auditName: auditNames.inventoryCount,
                title: 'Inventory Count',
                sticky: true,
                views: {
                    inventoryCount: {
                        templateUrl: 'app/plugins/inventoryCount/index.html',
                        controller: 'meevo.plugins.inventoryCount.InventoryCountController',
                        controllerAs: 'inventoryCount'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.InventoryCountSearchPage
            },
            {
                name: routeNames.inventoryTransfer,
                specialName: "'" + routeNames.inventoryTransfer + "'",
                auditName: auditNames.inventoryTransfer,
                title: 'Inventory Transfer',
                sticky: true,
                views: {
                    inventoryTransfer: {
                        templateUrl: 'app/plugins/inventoryTransfer/index.html',
                        controller: 'meevo.plugins.inventoryTransfer.InventoryTransferController',
                        controllerAs: 'inventoryTransfer'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.InventoryTransferSearchPage
            },
            {
                name: routeNames.employeeSupplyUsage,
                specialName: "'" + routeNames.employeeSupplyUsage + "'",
                auditName: auditNames.employeeSupplyUsage,
                title: 'Employee Supply Usage',
                sticky: true,
                views: {
                    employeeSupplyUsage: {
                        templateUrl: 'app/plugins/employeeSupplyUsage/index.html',
                        controller: 'meevo.plugins.employeeSupplyUsage.EmployeeSupplyUsageController',
                        controllerAs: 'employeeSupplyUsage'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.EmployeeSupplyUsagePage
            },
            {
                name: routeNames.purchaseOrder,
                specialName: "'" + routeNames.purchaseOrder + "'",
                auditName: auditNames.purchaseOrder,
                title: 'Purchase Order',
                sticky: true,
                views: {
                    purchaseOrder: {
                        templateUrl: 'app/plugins/purchaseOrder/index.html',
                        controller: 'meevo.plugins.purchaseOrder.PurchaseOrderController',
                        controllerAs: 'purchaseOrder'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.PurchaseOrdersSearchPage
            },
            {
                name: routeNames.inventoryReturns,
                specialName: "'" + routeNames.inventoryReturns + "'",
                auditName: auditNames.inventoryReturns,
                title: 'Inventory Returns',
                sticky: true,
                views: {
                    inventoryReturns: {
                        templateUrl: 'app/plugins/inventoryReturns/index.html',
                        controller: 'meevo.plugins.inventoryReturns.InventoryReturnsController',
                        controllerAs: 'inventoryReturns'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.InventoryReturnSearchPage
            },
            {
                name: routeNames.notificationTemplates,
                specialName: "'" + routeNames.notificationTemplates + "'",
                auditName: auditNames.notificationTemplates,
                title: 'Notification Templates',
                sticky: true,
                views: {
                    notificationTemplates: {
                        templateUrl: 'app/plugins/notificationTemplates/index.html',
                        controller: 'meevo.plugins.notificationTemplates.NotificationTemplatesController',
                        controllerAs: 'notificationTemplates'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.NotificationTemplateSearchPage
            },
            {
                name: routeNames.equipment,
                specialName: "'" + routeNames.equipment + "'",
                title: 'Equipment',
                sticky: true,
                views: {
                    equipment: {
                        templateUrl: 'app/plugins/equipment/index.html',
                        controller: 'meevo.plugins.equipment.EquipmentController',
                        controllerAs: 'equipment'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.EquipmentSearchPage
            },
            {
                name: routeNames.giftCardTypes,
                specialName: "'" + routeNames.giftCardTypes + "'",
                auditName: auditNames.giftCardTypes,
                title: 'HEADER_GIFT_CARD_TYPES',
                sticky: true,
                views: {
                    giftCardTypes: {
                        templateUrl: 'app/plugins/giftCardTypes/index.html',
                        controller: 'meevo.plugins.giftCardTypes.GiftCardTypesController',
                        controllerAs: 'giftCardTypes'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.GiftCardTypeSearchPage
            },
            {
                name: routeNames.walkinManagerSettings,
                specialName: "'" + routeNames.walkinManagerSettings + "'",
                auditName: auditNames.walkinManagerSettings,
                title: 'Walk-In Manager Settings',
                sticky: true,
                views: {
                    walkinManagerSettings: {
                        templateUrl: 'app/plugins/walkinManagerSettings/index.html',
                        controller: 'meevo.plugins.walkinManagerSettings.WalkinManagerSettingsController',
                        controllerAs: 'walkinManagerSettings'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.WalkInManagerSettingMainSettings
            },
            {
                name: routeNames.walkinManagerKiosk,
                specialName: "'" + routeNames.walkinManagerKiosk + "'",
                auditName: auditNames.walkinManagerKiosk,
                title: 'Walk-In Manager Kiosk',
                sticky: true,
                views: {
                    walkinManagerKiosk: {
                        templateUrl: 'app/plugins/walkinManagerKiosk/index.html',
                        controller: 'meevo.plugins.walkinManagerKiosk.walkinManagerKioskController',
                        controllerAs: 'walkinManagerKiosk'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.WalkInManagerKioskPage
            },
            {
                name: routeNames.userDefinedControls,
                specialName: "'" + routeNames.userDefinedControls + "'",
                auditName: auditNames.userDefinedControls,
                title: 'Custom Fields',
                sticky: true,
                views: {
                    userDefinedControls: {
                        templateUrl: 'app/plugins/userDefinedControls/index.html',
                        controller: 'meevo.plugins.userDefinedControls.UserDefinedControlsController',
                        controllerAs: 'userDefinedControls'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.UserDefinedFieldPage
            },
            {
                name: routeNames.walkinManager,
                specialName: "'" + routeNames.walkinManager + "'",
                auditName: auditNames.walkinManager,
                title: 'Walk-In Manager',
                sticky: true,
                views: {
                    walkinManager: {
                        templateUrl: 'app/plugins/walkinManager/index.html',
                        controller: 'meevo.plugins.walkinManager.WalkinManagerController',
                        controllerAs: 'walkinManager'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.WalkInManagerPage,
                onReactivate: ['meevo.plugins.walkinManager.WalkInSettingsService', 'meevo.components.busy.BusyService',
                    (settingsService: Meevo.Plugins.WalkinManager.IWalkInSettingsService, busyService: Meevo.Components.Busy.IBusyService) => {
                        busyService.start();
                        settingsService.fetchSettings().finally(() => busyService.stop());
                    }
                ]
            },
            {
                name: routeNames.walkinManagerDisplay,
                specialName: "'" + routeNames.walkinManagerDisplay + "'",
                auditName: auditNames.walkinManagerDisplay,
                title: 'Walk-In Manager Display',
                sticky: true,
                views: {
                    walkinManagerDisplay: {
                        templateUrl: 'app/plugins/walkinManagerDisplay/index.html',
                        controller: 'meevo.plugins.walkinManagerDisplay.walkinManagerDisplayController',
                        controllerAs: 'walkinManagerDisplay'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.WalkInManagerDisplayPage
            },
            {
                name: routeNames.packageTypes,
                specialName: "'" + routeNames.packageTypes + "'",
                auditName: auditNames.packageTypes,
                title: 'HERO_SUB_PACKAGES',
                sticky: true,
                views: {
                    packageTypes: {
                        templateUrl: 'app/plugins/packageTypes/index.html',
                        controller: 'meevo.plugins.packageTypes.PackageTypesController',
                        controllerAs: 'packageTypes'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.PackageSearchPage
            },
            {
                name: routeNames.ipRestrictions,
                specialName: "'" + routeNames.ipRestrictions + "'",
                auditName: auditNames.ipRestrictions,
                title: 'IP Restrictions',
                sticky: true,
                views: {
                    ipRestrictions: {
                        templateUrl: 'app/plugins/ipRestrictions/index.html',
                        controller: 'meevo.plugins.ipRestrictions.IpRestrictionsController',
                        controllerAs: 'ipRestrictions'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.IpRestrictionMain
            },
            {
                name: routeNames.marketPricing,
                specialName: "'" + routeNames.marketPricing + "'",
                auditName: auditNames.marketPricing,
                title: 'Price Management',
                sticky: true,
                views: {
                    marketPricing: {
                        templateUrl: 'app/plugins/marketPricing/index.html',
                        controller: 'meevo.plugins.marketPricing.marketPricingController',
                        controllerAs: 'marketPricing'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.MarketPricingSearchPage
            },
            {
                name: routeNames.reportingHierarchy,
                specialName: "'" + routeNames.reportingHierarchy + "'",
                title: 'Reporting Hierarchy',
                sticky: true,
                views: {
                    reportingHierarchy: {
                        templateUrl: 'app/plugins/reportingHierarchy/index.html',
                        controller: 'meevo.plugins.reportingHierarchy.ReportingHierarchyController',
                        controllerAs: 'reportingHierarchy'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.BlockTypeSearchPage
            },
            {
                name: routeNames.profileSettings,
                specialName: "'" + routeNames.profileSettings + "'",
                auditName: auditNames.profileSettings,
                title: 'My Profile',
                sticky: true,
                views: {
                    profileSettings: {
                        templateUrl: 'app/plugins/profileSettings/index.html',
                        controller: 'meevo.plugins.profileSettings.ProfileSettingsController',
                        controllerAs: 'profileSettings'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ProfileSettingMain
            },
            {
                name: routeNames.holiday,
                specialName: "'" + routeNames.holiday + "'",
                title: 'Business Holidays',
                sticky: true,
                views: {
                    holiday: {
                        templateUrl: 'app/plugins/holiday/index.html',
                        controller: 'meevo.plugins.holiday.HolidayController',
                        controllerAs: 'holiday'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.HolidaysMain
            },
            {
                name: routeNames.notificationSetting,
                specialName: "'" + routeNames.notificationSetting + "'",
                title: 'Notification Settings',
                sticky: true,
                views: {
                    notificationSetting: {
                        templateUrl: 'app/plugins/notificationSetting/index.html',
                        controller: 'meevo.plugins.notificationSetting.NotificationSettingController',
                        controllerAs: 'notificationSetting'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.NotificationSettingMain
            },
            //
            {
                name: routeNames.tax,
                specialName: "'" + routeNames.tax + "'",
                title: 'HERO_SUB_CURRENCYTAX',
                sticky: true,
                views: {
                    tax: {
                        templateUrl: 'app/plugins/tax/index.html',
                        controller: 'meevo.plugins.tax.TaxController',
                        controllerAs: 'tax'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.CurrencyAndTaxMain
            },
            {
                name: routeNames.merchantAccounts,
                specialName: "'" + routeNames.merchantAccounts + "'",
                auditName: auditNames.merchantAccounts,
                title: 'HERO_SUB_MERCHANT_ACCOUNTS',
                sticky: true,
                views: {
                    merchantAccounts: {
                        templateUrl: 'app/plugins/merchantAccounts/index.html',
                        controller: 'meevo.plugins.merchantAccounts.MerchantAccountsController',
                        controllerAs: 'merchantAccounts'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.MerchantAccountSearchPage
            },
            {
                name: routeNames.timeClock,
                specialName: "'" + routeNames.timeClock + "'",
                title: 'Time Clock',
                sticky: true,
                views: {
                    timeClock: {
                        templateUrl: 'app/plugins/timeClock/index.html',
                        controller: 'meevo.plugins.timeClock.TimeClockController',
                        controllerAs: 'timeClock'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.TimeClockPage
            },
            {
                name: routeNames.eventSchedules,
                specialName: "'" + routeNames.eventSchedules + "'",
                title: 'Events',
                sticky: true,
                views: {
                    eventSchedules: {
                        templateUrl: 'app/plugins/eventSchedule/index.html',
                        controller: 'meevo.plugins.eventSchedule.EventScheduleController',
                        controllerAs: 'eventSchedule'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.EventsSchedulePage
            },
            {
                name: routeNames.clientPoint,
                specialName: "'" + routeNames.clientPoint + "'",
                auditName: auditNames.clientPoint,
                title: 'Points',
                sticky: true,
                views: {
                    clientPoint: {
                        templateUrl: 'app/plugins/clientPoint/index.html',
                        controller: 'meevo.plugins.clientPoint.ClientPointController',
                        controllerAs: 'clientPoint'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ClientPointManagerSearchPage
            },
            {
                name: routeNames.compensationSettings,
                specialName: "'" + routeNames.compensationSettings + "'",
                title: 'Payroll Settings',
                sticky: true,
                views: {
                    compensationSettings: {
                        templateUrl: 'app/plugins/compensationSettings/index.html',
                        controller: 'meevo.plugins.compensationSettings.compensationSettingsController',
                        controllerAs: 'compensationSettings'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },

                noun: Meevo.Model.NounEnum.PayrollSettingsMain
            },
            {
                name: routeNames.cultureSettings,
                specialName: "'" + routeNames.cultureSettings + "'",
                title: 'Cultural Settings',
                sticky: true,
                views: {
                    cultureSettings: {
                        templateUrl: 'app/plugins/cultureSettings/index.html',
                        controller: 'meevo.plugins.cultureSettings.cultureSettingsController',
                        controllerAs: 'cultureSettings'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },

                noun: Meevo.Model.NounEnum.CulturalSettingsMain
            },
            {
                name: routeNames.smartCenters,
                specialName: "'" + routeNames.smartCenters + "'",
                title: 'HERO_SUB_SMARTCENTER_DESIGNER',
                auditName: auditNames.smartCenters,
                sticky: true,
                views: {
                    smartCenters: {
                        templateUrl: 'app/plugins/smartCenter/maintenance/index.html',
                        controller: 'meevo.plugins.smartCenter.SmartCenterMaintenanceController',
                        controllerAs: 'smartCenters'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.SmartCenterDesignerSearchPage
            },
            {
                name: routeNames.payroll,
                specialName: "'" + routeNames.payroll + "'",
                auditName: auditNames.payroll,
                title: 'Payroll',
                sticky: true,
                views: {
                    payroll: {
                        templateUrl: 'app/plugins/payroll/views/index.html',
                        controller: 'meevo.plugins.payroll.PayrollController',
                        controllerAs: 'payroll'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.PayrollPage
            },
            {
                name: routeNames.giftCardBalance,
                specialName: "'" + routeNames.giftCardBalance + "'",
                auditName: auditNames.giftCardBalance,
                title: 'LABEL_GIFT_CARD_BALANCE',
                sticky: true,
                views: {
                    giftCardBalance: {
                        templateUrl: 'app/plugins/giftCardBalance/index.html',
                        controller: 'meevo.plugins.giftCardBalance.GiftCardBalanceController',
                        controllerAs: 'giftCardBalance'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.GiftCardBalancePage
            },
            {
                name: routeNames.giftCardIntegration,
                specialName: "'" + routeNames.giftCardIntegration + "'",
                title: 'LABEL_GIFT_CARD_INTEGRATION',
                sticky: true,
                views: {
                    giftCardIntegration: {
                        templateUrl: 'app/plugins/giftCardIntegration/index.html',
                        controller: 'meevo.plugins.giftCardIntegration.GiftCardIntegrationController',
                        controllerAs: 'giftCardIntegration'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                //noun: Meevo.Model.NounEnum.GiftCardIntegration
            },
            {
                name: routeNames.activityLog,
                specialName: "'" + routeNames.activityLog + "'",
                auditName: auditNames.activityLog,
                title: 'Activity Log',
                sticky: true,
                views: {
                    activityLog: {
                        templateUrl: 'app/plugins/activityLog/index.html',
                        controller: 'meevo.plugins.activityLog.ActivityLogController',
                        controllerAs: 'activityLog'
                    }
                },
                noun: Meevo.Model.NounEnum.ActivityLogPage
            },
            {
                name: routeNames.alertsManager,
                specialName: "'" + routeNames.alertsManager + "'",
                auditName: auditNames.alertsManager,
                title: 'Alerts Manager',
                sticky: true,
                views: {
                    alertsManager: {
                        templateUrl: 'app/plugins/alertsManager/index.html',
                        controller: 'meevo.plugins.alertsManager.AlertsManagerController',
                        controllerAs: 'alertsManager'
                    }
                },
                noun: Meevo.Model.NounEnum.AlertManagerPage
            },
            {
                name: routeNames.alertsLog,
                specialName: "'" + routeNames.alertsLog + "'",
                auditName: auditNames.alertsLog,
                title: 'Alerts Log',
                sticky: true,
                views: {
                    alertsLog: {
                        templateUrl: 'app/plugins/alertsLog/index.html',
                        controller: 'meevo.plugins.alertsLog.AlertsLogController',
                        controllerAs: 'alertsLog'
                    }
                },
                noun: Meevo.Model.NounEnum.AlertLogsPage
            },
            {
                name: routeNames.imageGalleryCategory,
                specialName: "'" + routeNames.imageGalleryCategory + "'",
                auditName: auditNames.imageGalleryCategory,
                title: 'Image Gallery Categories',
                sticky: true,
                views: {
                    imageGalleryCategory: {
                        templateUrl: 'app/plugins/imageGalleryCategory/index.html',
                        controller: 'meevo.plugins.imageGalleryCategory.imageGalleryCategoryController',
                        controllerAs: 'imageGalleryCategory'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ImageGalleryCategorySearchPage
            },
            {
                name: routeNames.packageLookup,
                specialName: "'" + routeNames.packageLookup + "'",
                auditName: auditNames.packageLookup,
                title: 'Package Lookup',
                sticky: true,
                views: {
                    packageLookup: {
                        templateUrl: 'app/plugins/packageLookup/index.html',
                        controller: 'meevo.plugins.packageLookup.PackageLookupController',
                        controllerAs: 'packageLookup'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.PackageLookupPage
            },
            {
                name: routeNames.basicEmailMarketing,
                specialName: "'" + routeNames.basicEmailMarketing + "'",
                auditName: auditNames.basicEmailMarketing,
                title: 'HERO_SUB_CLIENT_SELECTION',
                sticky: true,
                views: {
                    basicEmailMarketing: {
                        templateUrl: 'app/plugins/basicEmailMarketing/index.html',
                        controller: 'meevo.plugins.basicEmailMarketing.BasicEmailMarketingController',
                        controllerAs: 'basicEmailMarketing'
                    }
                },
                noun: Meevo.Model.NounEnum.BasicMarketingPage
            },
            {
                name: routeNames.departments,
                specialName: "'" + routeNames.departments + "'",
                auditName: auditNames.departments,
                title: 'Departments',
                sticky: true,
                views: {
                    departments: {
                        templateUrl: 'app/plugins/departments/index.html',
                        controller: 'meevo.plugins.departments.DepartmentsController',
                        controllerAs: 'departments'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.DepartmentSearchPage
            },
            {
                name: routeNames.departmentGoal,
                specialName: "'" + routeNames.departmentGoal + "'",
                title: 'Overall/Department Goals',
                sticky: true,
                views: {
                    departmentGoal: {
                        templateUrl: 'app/plugins/departmentGoal/index.html',
                        controller: 'meevo.plugins.departmentGoal.DepartmentGoalController',
                        controllerAs: 'departmentGoal'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                }
            },
            {
                name: routeNames.employeeGoal,
                specialName: "'" + routeNames.employeeGoal + "'",
                title: 'Employee Goals',
                sticky: true,
                views: {
                    employeeGoal: {
                        templateUrl: 'app/plugins/employeeGoal/index.html',
                        controller: 'meevo.plugins.employeeGoal.EmployeeGoalController',
                        controllerAs: 'employeeGoal'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                }
            },
            {
                name: routeNames.dashboardGoals,
                specialName: "'" + routeNames.dashboardGoals + "'",
                auditName: auditNames.dashboardGoals,
                title: 'Goals Dashboard',
                sticky: true,
                views: {
                    dashboardGoals: {
                        templateUrl: 'app/plugins/dashboardGoals/index.html',
                        controller: 'meevo.plugins.dashboardGoals.DashboardGoalsController',
                        controllerAs: 'dashboardGoals'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.GoalsDashboardPage
            },
            {
                name: routeNames.accountsync,
                specialName: "'" + routeNames.accountsync + "'",
                auditName: auditNames.accountsync,
                title: 'QB Integration',
                sticky: true,
                views: {
                    quickbooksOnline: {
                        templateUrl: 'app/plugins/accountsync/index.html',
                        controller: 'meevo.plugins.accountsync.AccountsyncController',
                        controllerAs: 'accountsync'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.QuickBooksOnlinePage
            },
            {
                name: routeNames.quickbooksDesktop,
                specialName: "'" + routeNames.quickbooksDesktop + "'",
                auditName: auditNames.quickbooksDesktop,
                title: 'QB Desktop',
                sticky: true,
                views: {
                    quickbooksDesktop: {
                        templateUrl: 'app/plugins/quickbooksDesktop/index.html',
                        controller: 'meevo.plugins.quickbooksDesktop.QuickbooksDesktopController',
                        controllerAs: 'quickbooksDesktop'
                    }
                },
                noun: Meevo.Model.NounEnum.QuickBooksDesktopPage
            },
            {
                name: routeNames.egifts,
                specialName: "'" + routeNames.egifts + "'",
                auditName: auditNames.egifts,
                title: 'eGift',
                sticky: true,
                views: {
                    egift: {
                        templateUrl: 'app/plugins/egifts/index.html',
                        controller: 'meevo.plugins.egifts.EgiftsController',
                        controllerAs: 'egifts'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.Egift
            },
            {
                name: routeNames.shippingFees,
                specialName: "'" + routeNames.shippingFees + "'",
                auditName: auditNames.shippingFees,
                title: 'Shipping Fees',
                sticky: true,
                views: {
                    shippingFees: {
                        templateUrl: 'app/plugins/shippingFees/index.html',
                        controller: 'meevo.plugins.shippingFees.ShippingFeesController',
                        controllerAs: 'shippingFees'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ShippingFee
            },
            {
                name: routeNames.consumerAppSettings,
                specialName: "'" + routeNames.consumerAppSettings + "'",
                title: 'Salon Connect',
                sticky: true,
                views: {
                    consumerAppSettings: {
                        controller: 'meevo.plugins.consumerAppSettings.ConsumerAppSettingsController',
                        controllerAs: 'consumerAppSettings'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.ClientSearchPage // todo: change to real one
            },
            {
                name: routeNames.paging,
                specialName: "'" + routeNames.paging + "'",
                title: 'Paging',
                sticky: true,
                views: {
                    paging: {
                        templateUrl: 'app/plugins/paging/index.html',
                        controller: 'meevo.plugins.paging.PagingController',
                        controllerAs: 'paging'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.Paging
            },
            {
                name: routeNames.meevoMessenger,
                specialName: "'" + routeNames.meevoMessenger + "'",
                title: 'HERO_SUB_MEEVO_MESSENGER',
                sticky: true,
                views: {
                    meevoMessenger: {
                        templateUrl: 'app/plugins/meevoMessenger/index.html',
                        controller: 'meevo.plugins.meevoMessenger.MeevoMessengerController',
                        controllerAs: 'meevoMessenger'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.Textel
            },
            {
                name: routeNames.meevoMessengerSettings,
                specialName: "'" + routeNames.meevoMessengerSettings + "'",
                title: 'HERO_SUB_MEEVO_MESSENGER_SETTINGS',
                sticky: true,
                views: {
                    meevoMessengerSettings: {
                        templateUrl: 'app/plugins/meevoMessengerSettings/index.html',
                        controller: 'meevo.plugins.meevoMessengerSettings.MeevoMessengerSettingsController',
                        controllerAs: 'meevoMessengerSettings'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.TextelSettings
            },
            {
                name: routeNames.textelBlast,
                specialName: "'" + routeNames.textelBlast + "'",
                title: 'HERO_SUB_TEXTEL_BLAST',
                sticky: true,
                views: {
                    textelBlast: {
                        templateUrl: 'app/plugins/textelBlast/index.html',
                        controller: 'meevo.plugins.textelBlast.TextelBlastController',
                        controllerAs: 'textelBlast'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.TextelMarketing
            },
            {
                name: routeNames.meevoStore,
                specialName: "'" + routeNames.meevoStore + "'",
                title: 'HERO_SUB_MEEVOSTORE',
                sticky: true,
                deepStateRedirect: { default: routeNames.meevoStore + ".home" },
                views: {
                    meevoStore: {
                        templateUrl: 'app/plugins/meevoStore/index.html',
                        controller: 'meevo.plugins.meevoStore.MeevoStoreController',
                        controllerAs: 'meevoStore'
                    },
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.MeevoStore
            },
            {
                name: routeNames.pointPromotionCampaign,
                title: 'HERO_SUB_CLIENT_POINT_PROMOTIONS',
                specialName: "'" + routeNames.pointPromotionCampaign + "'",
                auditName: auditNames.pointPromotionCampaign,
                sticky: true,
                views: {
                    pointPromotionCampaign: {
                        templateUrl: 'app/plugins/pointPromotionCampaign/index.html',
                        controller: 'meevo.plugins.pointPromotionCampaign.PointPromotionCampaignController',
                        controllerAs: 'pointPromotionCampaign'
                    }
                },
                warnUponClose: false,
                noun: Meevo.Model.NounEnum.PointPromotionCampaignSearchPage
            },
            {
                name: routeNames.fieldLabels,
                specialName: "'" + routeNames.fieldLabels + "'",
                title: 'Field Labels',
                sticky: true,
                views: {
                    fieldLabels: {
                        templateUrl: 'app/plugins/fieldLabels/index.html',
                        controller: 'meevo.plugins.fieldLabels.FieldLabelsController',
                        controllerAs: 'fieldLabels'
                    }
                },
                noun: Meevo.Model.NounEnum.FieldLabelsPage
            },
            {
                name: routeNames.docsAndForms,
                specialName: "'" + routeNames.docsAndForms + "'",
                auditName: auditNames.docsAndForms,
                title: 'Docs & Forms',
                sticky: true,
                views: {
                    docsAndForms: {
                        templateUrl: 'app/plugins/docsAndForms/index.html',
                        controller: 'meevo.plugins.docsAndForms.DocsAndFormsController',
                        controllerAs: 'docsAndForms'
                    }
                },
                noun: Meevo.Model.NounEnum.DocsAndFormsSearchPage
            },
            {
                name: routeNames.docsAndFormsKiosk,
                specialName: "'" + routeNames.docsAndFormsKiosk + "'",
                title: 'Docs & Forms Kiosk',
                sticky: true,
                views: {
                    docsAndFormsKiosk: {
                        templateUrl: 'app/plugins/docsAndFormsKiosk/index.html',
                        controller: 'meevo.plugins.docsAndFormsKiosk.DocsAndFormsKioskController',
                        controllerAs: 'docsAndFormsKiosk'
                    }
                },
            },
            {
                name: routeNames.transworld,
                specialName: "'" + routeNames.transworld + "'",
                title: 'Transworld',
                sticky: true,
                views: {
                    transworld: {
                        templateUrl: 'app/plugins/transworld/index.html',
                        controller: 'meevo.plugins.transworld.transworldController',
                        controllerAs: 'transworld'
                    }
                },
                noun: Meevo.Model.NounEnum.Transworld
            },
            {   /*  TechSphere  */
                name: routeNames.techSphere,
                specialName: "'" + routeNames.techSphere + "'",
                title: 'TechSphere',
                sticky: true,
                views: {
                    techSphere: {
                        templateUrl: 'app/plugins/techSphere/index.html',
                        controller: 'meevo.plugins.techSphere.TechSphereController',
                        controllerAs: 'techSphere'
                    }
                },
                noun: Meevo.Model.NounEnum.TechSphere
            },

            {
                name: routeNames.aveda,
                specialName: "'" + routeNames.aveda + "'",
                title: 'Aveda',
                sticky: true,
                views: {
                    aveda: {
                        templateUrl: 'app/plugins/aveda/index.html',
                        controller: 'meevo.plugins.aveda.AvedaController',
                        controllerAs: 'aveda'
                    }
                },
                noun: Meevo.Model.NounEnum.Aveda
            },
            {
                name: routeNames.emmaAccountSettings,
                specialName: "'" + routeNames.emmaAccountSettings + "'",
                title: 'Emma',
                sticky: true,
                views: {
                    emmaAccountSettings: {
                        templateUrl: 'app/plugins/emmaAccountSettings/index.html',
                        controller: 'meevo.plugins.emmaAccountSettings.EmmaAccountSettingsController',
                        controllerAs: 'emmaAccountSettings'
                    }
                },
                noun: Meevo.Model.NounEnum.BasicMarketingPage
            },
            {
                name: routeNames.salesRankings,
                specialName: "'" + routeNames.salesRankings + "'",
                title: 'HERO_SUB_SALES_RANKINGS',
                sticky: true,
                views: {
                    salesRankings: {
                        templateUrl: 'app/plugins/salesRankings/index.html',
                        controller: 'meevo.plugins.salesRankings.SalesRankingsController',
                        controllerAs: 'salesRankings'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.SalesRanking
            },
            {
                name: routeNames.ratingsControlPanel,
                specialName: "'" + routeNames.ratingsControlPanel + "'",
                title: 'HERO_SUB_RATINGS_CONTROL_PANEL',
                sticky: true,
                views: {
                    ratingsControlPanel: {
                        templateUrl: 'app/plugins/ratingsControlPanel/index.html',
                        controller: 'meevo.plugins.ratingsControlPanel.RatingsControlPanelController',
                        controllerAs: 'ratingsControlPanel'
                    }
                },
                noun: Meevo.Model.NounEnum.RatingsControlPanel
            },
            {
                name: routeNames.servicesWizard,
                specialName: "'" + routeNames.servicesWizard + "'",
                title: 'Services Wizard',
                sticky: true,
                views: {
                    servicesWizard: {
                        templateUrl: 'app/plugins/servicesWizard/index.html',
                        controller: 'meevo.plugins.servicesWizard.servicesWizardController',
                        controllerAs: 'servicesWizard'
                    }
                },
                noun: Meevo.Model.NounEnum.ServicesWizard
            },
            {
                name: routeNames.student,
                specialName: "'" + routeNames.student + "'",
                auditName: auditNames.student,
                title: 'HERO_SUB_STUDENT',
                sticky: true,
                views: {
                    student: {
                        templateUrl: 'app/plugins/student/index.html',
                        controller: 'meevo.plugins.student.StudentController',
                        controllerAs: 'student'
                    }
                },
                noun: Meevo.Model.NounEnum.StudentSearchPage
            },
            {
                name: routeNames.clientIntake,
                specialName: "'" + routeNames.clientIntake + "'",
                title: 'HERO_SUB_CLIENTINTAKE',
                sticky: true,
                views: {
                    clientIntake: {
                        templateUrl: 'app/plugins/clientIntake/index.html',
                        controller: 'meevo.plugins.clientIntake.ClientIntakeController',
                        controllerAs: 'clientIntake'
                    }
                },
                noun: Meevo.Model.NounEnum.ClientIntakeFormPage
            },
            {
                name: routeNames.clientIntakeForm,
                specialName: "'" + routeNames.clientIntakeForm + "'",
                title: 'HERO_SUB_CLIENTINTAKE_FORM_BUILDER',
                sticky: true,
                views: {
                    clientIntakeForm: {
                        templateUrl: 'app/plugins/clientIntakeForm/index.html',
                        controller: 'meevo.plugins.clientIntakeForm.ClientIntakeFormController',
                        controllerAs: 'clientIntakeForm'
                    }
                },
                params: {
                    clientId: null,
                },
                noun: Meevo.Model.NounEnum.ClientIntakeForm
            },
            {
                name: routeNames.selfCheckInKiosk,
                specialName: "'" + routeNames.selfCheckInKiosk + "'",
                title: 'LABEL_SELF_CHECK_IN_KIOSK',
                sticky: true,
                deepStateRedirect: { default: routeNames.selfCheckInKiosk + ".login" },
                views: {
                    selfCheckInKiosk: {
                        templateUrl: 'app/plugins/selfCheckInKiosk/index.html',
                        controller: 'meevo.plugins.selfCheckInKiosk.SelfCheckInKioskController',
                        controllerAs: 'selfCheckInKiosk'
                    }
                },
                params: {
                  callback: null,
                  callbackState: null,
                  targetState: null,
                  actionState: null,
                  id: null
                },
                noun: Meevo.Model.NounEnum.SelfCheckInKiosk
            },
            {
                name: routeNames.selfCheckInKioskSettings,
                specialName: `'${routeNames.selfCheckInKioskSettings}'`,
                title: 'HERO_SUB_SELF_CHECK_IN_SETTINGS',
                sticky: true,
                views: {
                    selfCheckInKioskSettings: {
                        templateUrl: 'app/plugins/selfCheckInKioskSettings/index.html',
                        controller: 'meevo.plugins.selfCheckInKioskSettings.SelfCheckInKioskSettingsController',
                        controllerAs: 'selfCheckInKioskSettings'
                    }
                },
                noun: Meevo.Model.NounEnum.SelfCheckinSetting
            },
            {
                name: routeNames.employeeServiceTimesPricing,
                title: 'HERO_SUB_EMPLOYEE_SERVICE_TIMES_PRICING',
                specialName: `'${routeNames.employeeServiceTimesPricing}'`,
                sticky: true,
                views: {
                    employeeServiceTimesPricing: {
                        templateUrl: 'app/plugins/employeeServiceTimesPricing/index.html',
                        controller: 'meevo.plugins.employeeServiceTimesPricing.EmployeeServiceTimesPricingController',
                        controllerAs: 'employeeServiceTimesPricing'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.EmployeeServiceTimesPricingPage
            },
            {
                name: routeNames.fiveStarRatingSetting,
                specialName: `'${routeNames.fiveStarRatingSetting}'`,
                title: 'LABEL_FIVE_STAR_RATING_SETTINGS',
                sticky: true,
                views: {
                    fiveStarRatingSetting: {
                        templateUrl: 'app/plugins/fiveStarRatingSetting/index.html',
                        controller: 'meevo.plugins.fiveStarRatingSettings.FiveStarRatingsSettingsController',
                        controllerAs: 'fiveStarRatingSetting'
                    }
                },
                noun: Meevo.Model.NounEnum.FiveStarRatingsSetting
            },
            {
                name: routeNames.serviceCharges,
                specialName: "'" + routeNames.serviceCharges + "'",
                title: 'Service Charges',
                sticky: true,
                views: {
                    serviceCharges: {
                        templateUrl: 'app/plugins/serviceCharges/index.html',
                        controller: 'meevo.plugins.serviceCharges.ServiceChargesController',
                        controllerAs: 'serviceCharges'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.EventsSchedulePage
            },
            {
                name: routeNames.fameAdvantage,
                specialName: `'${routeNames.fameAdvantage}'`,
                title: 'HERO_SUB_FAME_ADVANTAGE',
                sticky: true,
                views: {
                    fameAdvantage: {
                        templateUrl: 'app/plugins/fameAdvantage/index.html',
                        controller: 'meevo.plugins.fameAdvantage.FameAdvantageController',
                        controllerAs: 'fameAdvantage'
                    }
                },
                noun: Meevo.Model.NounEnum.SelfCheckinSetting
            },
            {
                name: routeNames.adpRunIntegration,
                title: 'ADP Integration',
                specialName: "'" + routeNames.adpRunIntegration + "'",
                sticky: true,
                views: {
                    adpRunIntegration: {
                        templateUrl: 'app/plugins/adpRunIntegration/index.html',
                        controller: 'meevo.plugins.adpRunIntegration.adpRunIntegrationController',
                        controllerAs: 'adpRunIntegration'
                    }
                },
                noun: Meevo.Model.NounEnum.Integration
            },
            {
                name: routeNames.meevoBi,
                title: 'Meevo BI',
                specialName: "'" + routeNames.meevoBi + "'",
                sticky: true,
                views: {
                    meevoBi: {
                        templateUrl: 'app/plugins/meevoBi/index.html',
                        controller: 'meevo.plugins.meevoBi.meevoBiController',
                        controllerAs: 'meevoBi'
                    }
                },
                noun: Meevo.Model.NounEnum.MeevoBI
            },
            {
                name: routeNames.adpWfnIntegration,
                title: 'ADP WFN Integration',
                specialName: "'" + routeNames.adpWfnIntegration + "'",
                sticky: true,
                views: {
                    adpWfnIntegration: {
                        templateUrl: 'app/plugins/adpWfnIntegration/index.html',
                        controller: 'meevo.plugins.adpWfnIntegration.adpWfnIntegrationController',
                        controllerAs: 'adpWfnIntegration'
                    }
                },
                noun: Meevo.Model.NounEnum.Integration
            },
            {
                name: routeNames.adpWiselyIntegration,
                title: 'ADP Wisely Integration',
                specialName: "'" + routeNames.adpWiselyIntegration + "'",
                sticky: true,
                views: {
                    adpWiselyIntegration: {
                        templateUrl: 'app/plugins/adpWiselyIntegration/index.html',
                        controller: 'meevo.plugins.adpWiselyIntegration.adpWiselyIntegrationController',
                        controllerAs: 'adpWiselyIntegration'
                    }
                },
                noun: Meevo.Model.NounEnum.Integration
            },            {
                name: routeNames.royaltyExport,
                title: 'Royalty Export',
                specialName: "'" + routeNames.royaltyExport + "'",
                sticky: true,
                views: {
                    royaltyExport: {
                        templateUrl: 'app/plugins/royaltyExport/index.html',
                        controller: 'meevo.plugins.royaltyExport.royaltyExportController',
                        controllerAs: 'royaltyExport'
                    }
                },
                noun: Meevo.Model.NounEnum.RoyaltyExport
            },
            {
                name: routeNames.onlinePresenceManagement,
                specialName: "'" + routeNames.onlinePresenceManagement + "'",
                title: 'YEXT_HERO_ONLINE_PRESENCE_MANAGEMENT',
                sticky: true,
                views: {
                    onlinePresenceManagement: {
                        templateUrl: 'app/plugins/yext/onlinePresenceManagement/index.html',
                        controller: 'meevo.plugins.onlinePresenceManagement.OnlinePresenceManagementController',
                        controllerAs: 'onlinePresenceManagement'
                    }
                },
                noun: Meevo.Model.NounEnum.OnlinePresenceManagement
            },
            {
                name: routeNames.onlinePresenceSettings,
                specialName: "'" + routeNames.onlinePresenceSettings + "'",
                title: 'HEADER_ONLINE_PRESENCE_SETTINGS',
                sticky: true,
                views: {
                    onlinePresenceSettings: {
                        templateUrl: 'app/plugins/onlinePresenceSettings/index.html',
                        controller: 'meevo.plugins.onlinePresenceSettings.OnlinePresenceSettingsController',
                        controllerAs: 'onlinePresenceSettings'
                    }
                },
                noun: Meevo.Model.NounEnum.OnlinePresenceSettings
            },
            {
                name: routeNames.systemToolbox,
                title: 'HERO_SUB_MEEVO_SYSTEM_TOOLBOX',
                specialName: "'" + routeNames.systemToolbox + "'",
                sticky: true,
                views: {
                    systemToolbox: {
                        templateUrl: 'app/plugins/systemToolbox/index.html',
                        controller: 'meevo.plugins.systemToolbox.systemToolboxController',
                        controllerAs: 'systemToolbox'
                    }
                },
                noun: Meevo.Model.NounEnum.SystemToolbox
            },
            {
                name: routeNames.meevoTheming,
                title: 'HERO_SUB_MEEVO_THEMING',
                specialName: "'" + routeNames.meevoTheming + "'",
                sticky: true,
                views: {
                    meevoTheming: {
                        templateUrl: 'app/plugins/meevoTheming/index.html',
                        controller: 'meevo.plugins.meevoTheming.meevoThemingController',
                        controllerAs: 'meevoTheming'
                    }
                },
                noun: Meevo.Model.NounEnum.MeevoTheming
            },
            {
                name: routeNames.yieldManagementStrategy,
                title: 'LABEL_YIELD_MANAGEMENT_STRATEGY',
                specialName: "'" + routeNames.yieldManagementStrategy + "'",
                auditName: auditNames.yieldManagementStrategy,
                sticky: true,
                views: {
                    yieldManagementStrategy: {
                        templateUrl: 'app/plugins/yieldManagementStrategy/index.html',
                        controller: 'meevo.plugins.yieldManagementStrategy.YieldManagementStrategyController',
                        controllerAs: 'ctrl'
                    }
                },
                noun: Meevo.Model.NounEnum.YieldManagementStrategy
            },
            {
                name: routeNames.yieldManagementProgram,
                title: 'LABEL_YIELD_MANAGEMENT_PROGRAM',
                specialName: "'" + routeNames.yieldManagementProgram + "'",
                auditName: auditNames.yieldManagementProgram,
                sticky: true,
                views: {
                    yieldManagementProgram: {
                        templateUrl: 'app/plugins/yieldManagementProgram/index.html',
                        controller: 'meevo.plugins.yieldManagementProgram.YieldManagementProgramController',
                        controllerAs: 'ctrl'
                    }
                },
                noun: Meevo.Model.NounEnum.YieldManagementProgram
            },
            {
                name: routeNames.systemVersions,
                specialName: "'" + routeNames.systemVersions + "'",
                title: 'Versions',
                sticky: true,
                views: {
                    systemVersions: {
                        templateUrl: 'app/plugins/systemVersions/sectionViews/main.html',
                        controller: 'meevo.plugins.systemVersions.SystemVersionsController',
                        controllerAs: 'systemVersions'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.PayrollPage
            },
            { //update here Client App
                name: routeNames.clientApp,
                title: 'LABEL_CLIENT_APP',
                specialName: "'" + routeNames.clientApp + "'",
                auditName: auditNames.clientApp,
                sticky: true,
                views: {
                    clientApp: {
                        templateUrl: 'app/plugins/clientApp/index.html',
                        controller: 'meevo.plugins.clientApp.ClientAppController',
                        controllerAs: 'clientApp'
                    }
                },
                noun: Meevo.Model.NounEnum.ClientApp
            },
            {
                name: routeNames.usageReasons,
                specialName: "'" + routeNames.usageReasons + "'",
                auditName: auditNames.usageReasons,
                title: 'HERO_SUB_USAGE_REASONS',
                sticky: true,
                views: {
                    usageReasons: {
                        templateUrl: 'app/plugins/usageReasons/index.html',
                        controller: 'meevo.plugins.usageReasons.UsageReasonsController',
                        controllerAs: 'usageReasons'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.UsageReason
            },//update here Client App
            {
                name: routeNames.tippy,
                title: 'LABEL_TIPPY_INTEGRATION',
                specialName: "'" + routeNames.tippy + "'",
                auditName: auditNames.tippy,
                sticky: true,
                views: {
                    tippy: {
                        templateUrl: 'app/plugins/tippy/index.html',
                        controller: 'meevo.plugins.tippy.TippyController',
                        controllerAs: 'ctrl'
                    }
                },
                noun: Meevo.Model.NounEnum.Tippy
            },
            {
                name: routeNames.merchantOnboardingTesting,
                specialName: "'" + routeNames.merchantOnboardingTesting + "'",
                title: 'HEADER_MERCHANT_ONBOARDING_TESTING_SETTINGS',
                sticky: true,
                views: {
                    merchantonboardingtesting: {
                        templateUrl: 'app/plugins/merchantAccountsOnboardingTesting/index.html',
                        controller: 'meevo.plugins.merchantAccountsOnboardingTesting.MerchantAccountsOnboardingTestingController',
                        controllerAs: 'merchantAccountsOnboardingTesting'
                    }
                },
                params: {
                    callback: null,
                    callbackState: null,
                    targetState: null,
                    actionState: null,
                    id: null
                },
                noun: Meevo.Model.NounEnum.MerchantAccount
            },
            /** Interop Contexts */
            interopContext(routeNames.csvExport, `LABEL_DATA_EXPORT`),
            interopContext(routeNames.newFormBuilder, `Form Builder`),
            interopContext(routeNames.productBulkUpdate, `HERO_SUB_PRODUCT_BULK_UPDATE`),
            interopContext(routeNames.paymentPlans, 'HERO_PAYMENT_PLANS'),
            interopContext(routeNames.paymentRequests, 'LABEL_PAYMENTS'),
            interopContext(routeNames.meevoPay, 'LABEL_MEEVO_PAY'),
            interopContext(routeNames.schedulesManager, `HEADER_SCHEDULER`),
            interopContext(routeNames.pbiDashboards, 'LABEL_DASHBOARDS'),
            interopContext(routeNames.myMeevoApp, `LABEL_MY_MEEVO_APP`),
            interopContext(routeNames.timeOffRequests, 'LABEL_TIME_OFF_REQUESTS'),
            interopContext(routeNames.zapier, 'LABEL_ZAPIER_INTEGRATION'),
            interopContext(routeNames.onlineMembershipSettings, `LABEL_MEMBERSHIP_ONLINE_SETTINGS`),
            interopContext(routeNames.twoWaySmsOnboarding, 'SECTION_TWO_WAY_SMS_ONBOARDING'),
            interopContext(routeNames.advancedCustomBranding, 'HERO_SUB_CUSTOM_BRANDING'),
            interopContext(routeNames.businessPreferences, 'HERO_SUB_BUSPREFS'),
            interopContext(routeNames.bulkLiabilityUpdate, `LABEL_BULK_LIABILITY_UPDATE`, null, Model.NounEnum.BulkLiabilityUpdate),
            interopContext(routeNames.bulkLiabilityTransfer, `LABEL_BULK_LIABILITY_TRANSFER`, null, Model.NounEnum.BulkLiabilityTransfer),
            interopContext(routeNames.charts, 'HERO_SUB_CHARTS', null, Model.NounEnum.ChartsDefinitionSearchPage, auditNames.charts),
            interopContext(routeNames.salonInteractive, 'LABEL_SALON_INTERACTIVE'),
            interopContext(routeNames.clientRecordManagement, 'HERO_SUB_CLIENT_RECORD_MANAGEMENT', null, null, auditNames.clientRecordManagement),
        ];

        angular.forEach(contexts, (state: IContext) => {
            $stateProvider.state(state.name, state);
        });


        $urlRouterProvider.otherwise("/");

        $httpProvider.interceptors.push("meevo.components.interceptors.ExceptionInterceptor");
        $httpProvider.interceptors.push("meevo.components.interceptors.DateInterceptor");

        $provide.decorator('$mdDialog', ['$delegate', '$injector',
            ($delegate: ng.material.IDialogService, $injector) => {
                let show = $delegate.show;
                let hide = $delegate.hide;
                let cancel = $delegate.cancel;
                const baseModalShortcutsGroup: Meevo.Components.ShortCuts.IShortCutGroup = new ShortCutGroup([], {deactivateGlobal: true, groupLevel: Components.ShortCuts.GroupLevels.Modal});

                // note: injector needed for fixing "Circular Dependencies" error
                $delegate.show = (options) => {
                    $injector.get('meevo.components.short-cuts.ShortCutsService').activateGroup(baseModalShortcutsGroup);
                    return show(options);
                };

                $delegate.hide = (options) => {
                    $injector.get('meevo.components.short-cuts.ShortCutsService').deactivateGroup(baseModalShortcutsGroup);
                    return hide(options);
                };

                $delegate.cancel = (options) => {
                    $injector.get('meevo.components.short-cuts.ShortCutsService').deactivateGroup(baseModalShortcutsGroup);
                    return cancel(options);
                };

                return $delegate;
            }
        ]);

        // NOTE: See implementation at Meevo.Components.Interceptors.DateInterceptor
        //$httpProvider.defaults.transformResponse.push((responseData: any): any => {
        //  convertDateStringsToDates(responseData);
        //  return responseData;
        //});
    }

    /**
     * Configures the translation provider.
     * @param $translateProvider
     */
    function configureTranslations($translateProvider, meevoCdn, countryId) {

        $translateProvider.useStaticFilesLoader({
            prefix: meevoCdn + "/assets/i18n/",
            suffix: ".json?ver=2342324353"
        });

        /*  $translateProvider.useMessageFormatInterpolation() Instead Will Be Added To $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
        *   So We Can Use At Will For Pluralization Within Templates Using Single Brackets {variable} Within *.json
        *   By Default Translate Interpolation Uses {{variable}} Within *.json
        *   $translateProvider.useInterpolation('meevoTranslateInterpolation'); This Is Our Custom and Current Interpolation
        */


        $translateProvider.fallbackLanguage(countryId);
        $translateProvider.preferredLanguage(countryId);
        //$translateProvider.synchronizeLocale = true;


        //$translateProvider.useSanitizeValueStrategy('escape');
        // TODO: Revisit when localization for other languages are introduced
        // https://github.com/angular-translate/angular-translate/issues/1410
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');


    }

    /**
     * Configures Material Design DateLocale Provider.
     * https://stackoverflow.com/questions/32566416/change-format-of-md-datepicker-in-angular-material/43409002#43409002
     * @param $mdDateLocaleProvider
     */
    function configureDateLocaleProvider($mdDateLocaleProvider) {

        $mdDateLocaleProvider.parseDate = (dateString) => {
            var m = moment(dateString, 'L', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $mdDateLocaleProvider.formatDate = (date) => {
            var m = moment(date);
            return m.isValid() ? m.format('L') : '';
        };
    }

    /**
     * https://github.com/lgalfaso/angular-dynamic-locale/blob/master/README.md
     * @param tmhDynamicLocaleProvider
     * TODO: If Needed use Catching To Reduce Loading Time $translateProvider.useLoaderCache(true)
     */
    function configuretmhDynamicLocaleProvider(tmhDynamicLocaleProvider, countryId) {
        //tmhDynamicLocaleProvider.localeLocationPattern('https://code.angularjs.org/1.5.8/i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.localeLocationPattern('/assets/locale/angular-locale_{{locale}}.min.js');
        tmhDynamicLocaleProvider.defaultLocale(countryId); /* when done fires $localeChangeSuccess event */
    }

    function interopContext(name: string, title: string, targetRoute: string = null, noun: Model.NounEnum = null, auditName: string = null) {
        const views = {};
        views[name] = {
            templateUrl: 'app/plugins/interop/interop.html',
            controller: 'meevo.plugins.interop.InteropController',
            controllerAs: 'interop'
        };
        const context = {
            name: name,
            title: title,
            specialName: `'${name}'`,
            sticky: true,
            views: views,
            auditName: auditName,
            noun: noun,
            params: {
                targetRoute
            }
        }
        return context;
    }

    angular.module("meevo").config(config);
}

